var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "500px", width: "100%" } },
    [
      _c(
        "l-map",
        {
          ref: "mapSessions",
          staticStyle: { height: "100%" },
          attrs: { zoom: _vm.zoom, center: _vm.center, options: _vm.mapOptions }
        },
        [
          _c("l-tile-layer", {
            attrs: { url: _vm.url, attribution: _vm.attribution }
          }),
          _vm._v(" "),
          _vm._l(_vm.examSessions, function(examSession) {
            return _c("l-marker", {
              key: examSession.id,
              attrs: {
                "lat-lng": _vm.getLatLng(examSession),
                icon: _vm.getIcon(examSession),
                zIndexOffset: _vm.getZIndex(examSession)
              },
              on: {
                click: function($event) {
                  return _vm.emitExamCenterInfos(examSession.examCenter)
                },
                add: function($event) {
                  return _vm.onAddMarkers($event)
                }
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }